export enum Validation {
  normal = 'normal',
  ok = 'ok',
  warn = 'warn',
  error = 'error',
  flash = 'flash',
}
